import {charcoal} from '../../sass/v2/_exports.sass';

export const LogoutIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Logout"
      role="img"
    >
      <path
        fillRule="nonzero"
        d="M 6.667969 28 C 5.933594 28 5.304688 27.738281 4.785156 27.214844 C 4.261719 26.695312 4 26.066406 4 25.332031 L 4 6.667969 C 4 5.933594 4.261719 5.304688 4.785156 4.785156 C 5.304688 4.261719 5.933594 4 6.667969 4 L 16 4 L 16 6.667969 L 6.667969 6.667969 L 6.667969 25.332031 L 16 25.332031 L 16 28 Z M 21.332031 22.667969 L 19.5 20.734375 L 22.898438 17.332031 L 12 17.332031 L 12 14.667969 L 22.898438 14.667969 L 19.5 11.265625 L 21.332031 9.332031 L 28 16 Z M 21.332031 22.667969 "
        fill={color}
      />
    </svg>
  );
};
